<template>
  <Dialog
    v-model="dialogUpdateActor"
    icon="fas fa-pencil-alt"
    classBtn="mr-3"
    :width="750"
    title="キャラクター編集"
  >
    <template v-slot:content>
      <v-row>
        <v-col style="max-width: 300px">
          <h4>アバター</h4>
          <div class="text-center">
            <img height="72" :src="isAvatar" v-if="isAvatar" />
            <v-icon size="72" dark v-else>fas fa-user</v-icon>
          </div>
          <div class="avatar-list">
            <span />
            <v-avatar
              class="ma-2"
              :class="isAvatar == avatar ? 'is--active' : null"
              size="50"
              v-for="(avatar, index) in icon"
              @click="handleSelectAvatar(avatar)"
              :key="`avatar-${index}`"
            >
              <img :src="avatar" />
            </v-avatar>
          </div>
          <base-error
            v-show="isAvatarError && !isAvatar"
            class="my-3"
            message="アバターを選択してください"
          />

          <!-- Listen all -->
          <h4 class="my-2">音声データ</h4>
          <audio id="Audio" controls style="max-width: 270px" :key="audioKey">
            <source :src="audio ? audio.fileUrl : null" type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <base-upload type="audio" v-model="audio">
              <div slot="activator">
                <v-btn color="primary" small>ファイル選択</v-btn>
              </div>
            </base-upload>
          </div>
        </v-col>
        <v-col>
          <v-row>
            <strong>
              人物名
              <span class="red--text">*</span>
            </strong>
          </v-row>
          <v-row class="px-4">
            <v-text-field
              dense
              outlined
              v-model="actor_name"
              :error-messages="actorNameErrors"
              @input="$v.actor_name.$touch()"
              @blur="$v.actor_name.$touch()"
            />
          </v-row>
          <v-row class="mb-2">
            <strong>セリフ</strong>
          </v-row>
          <v-row class="px-4">
            <v-textarea
              :spellcheck="false"
              dense
              :auto-grow="true"
              outlined
              :rows="2"
              :error-messages="linesJpErrors"
              @input="$v.linesJp.value.$touch()"
              @blur="$v.linesJp.value.$touch()"
              v-model="linesJp.value"
            >
              <template v-slot:label>
                <span class="font-weight-bold mr-1">{{ linesJp.text }}</span>
                <span class="red--text" v-if="linesJp.key == 'ja'">*</span>
              </template>
            </v-textarea>
          </v-row>
          <v-row class="px-4" v-for="lang in language" :key="lang.key">
            <v-textarea
              :spellcheck="false"
              dense
              :auto-grow="true"
              outlined
              :rows="2"
              v-model="lang.value"
            >
              <template v-slot:label>
                <span class="font-weight-bold mr-1">{{ lang.text }}</span>
              </template>
            </v-textarea>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color @click="handleCancel">キャンセル</v-btn>
      <v-btn color="primary" :disabled="loading" @click="handleUpdateActor"
        >更新</v-btn
      >
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog/Dialog";
import { updateActor } from "@/api/Actor.api";
import { headersLang } from "@/utils/lang";
import uploadFile from "@/utils/uploadFile";
import { getIcon } from "@/api/Icon.api";
import mimix from "@/mixin";
export default {
  props: ["item"],
  mixins: [mimix.ValidateAddActor],
  components: { Dialog },
  data() {
    return {
      headersLang,
      dialogUpdateActor: false,
      actor_name: "",
      loading: false,
      audio: null,
      audioKey: 0,
      icon: [],
      isAvatar: null,
      isAvatarError: false,
      linesJp: { text: "日本語", key: "ja", value: "" },
      language: [
        { text: "日本語（かな）", key: "kana", value: "" },
        { text: "英語", key: "en", value: "" },
        { text: "中国語", key: "cn", value: "" },
        { text: "ベトナム語", key: "vn", value: "" },
        { text: "ベンガル語", key: "bn", value: "" },
        { text: "ポルトガル語", key: "pt", value: "" },
      ],
      keyIcon: [
        "エマ_右",
        "エマ_左",
        "中村_右",
        "中村_左",
        "アイン_右",
        "アイン_左",
        "アン_右",
        "アン_左",
        "サミー_右",
        "サミー_左",
        "メイリン_右",
        "メイリン_左",
        "エレーナ_右",
        "エレーナ_左",
        "川島_右",
        "川島_左",
        "ロミオ_右",
        "ロミオ_左",
        "吉田_右",
        "吉田_左",
        "伊藤_右",
        "伊藤_左",
        "高橋_右",
        "高橋_左",
        "女将",
        "女性",
        "2人",
        "3人",
        "みんな",
        "キャスター",
        "スタッフ",
        "レポーター",
        "不動産屋",
        "先生",
        "先輩",
        "医者",
        "占い師",
        "司会",
        "女の子",
        "客",
        "店員",
        "気象予報士",
        "男性",
        "美容師",
        "職員",
        "薬剤師",
        "職員",
        "薬剤師",
        "行司",
        "車掌",
        "郵便局員",
        "？",
        "駅員",
      ],
    };
  },
  created() {},
  watch: {
    dialogUpdateActor: async function () {
      await this.fetchIcon();
      const { image, audio_url, content, actor_name } = this.item;
      this.isAvatar = image;
      if (audio_url) {
        this.audio = { fileUrl: audio_url };
        this.audioKey++;
      }
      this.linesJp.value = content["ja"];
      this.actor_name = actor_name;
      this.language.forEach((e) => {
        if (content[e.key]) {
          e.value = content[e.key];
        }
      });
    },
    "audio.fileUrl": function () {
      this.audioKey++;
    },
  },
  methods: {
    async fetchIcon() {
      await getIcon().then(({ result }) => {
        const that = this;
        this.icon = [];
        const { _, keyIcon } = this;
        _.forEach(keyIcon, function (o) {
          _.forEach(result, function (item) {
            if (item.search(o) != -1) {
              that.icon.push(item);
            }
          });
        });
      });
    },
    handleSelectAvatar(avatar) {
      const { loading } = this;
      if (!loading) {
        this.isAvatar = avatar;
      }
    },
    async handleUpdateActor() {
      this.loading = true;
      const { actor_name, audio, isAvatar, linesJp, language } = this;
      this.$v.$touch();
      if (!isAvatar) {
        this.isAvatarError = true;
      } else {
        this.isAvatarError = false;
      }

      if (this.isAvatarError || this.$v.$anyError) return;
      this.loading = true;
      var content = { ja: linesJp["value"] };
      language.forEach((e) => (content[e.key] = e.value));
      let params = {
        conversation_id: this.$route.params.skit,
        section_id: this.$route.params.section,
        id: this.item.Id,
        detail: {
          audio,
          image: isAvatar,
          actor_name,
          content,
        },
      };
      params = await this.checkFile(params);
      await updateActor(params)
        .then(() => {
          this.dialogConversationData = false;
          this.$emit("resetList");
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async checkFile(params) {
      if (params.detail.audio && params.detail.audio.file) {
        await uploadFile(params.detail.audio.file, "audio").then((e) => {
          params.detail.audio = e;
        });
      } else {
        delete params.detail.audio;
        console.log("params.detail: ", params.detail);
      }
      return params;
    },
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.is--active {
  border: 2px solid orange;
}
.avatar-list {
  border: 2px solid orange;
  border-radius: 8px;
  margin-top: 20px;
  &::after {
    content: "";
    position: absolute;
    width: 0px;
    border-right: 13.5px solid transparent;
    border-bottom: 17px solid #ffffff;
    border-left: 12.7px solid transparent;
    left: 9.4rem;
    top: 10.96rem;
  }
  span {
    &::after {
      content: "";
      position: absolute;
      width: 23.5px;
      border-right: 13.5px solid transparent;
      border-bottom: 18.5px solid orange;
      border-left: 12.5px solid transparent;
      left: 9.4rem;
      top: 10.7rem;
    }
  }
}
</style>